import React, { useEffect, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import styles from "../../pages/Time/time.module.scss";
import { Dialog } from "@progress/kendo-react-dialogs";
import {
  AmountFormatCell,
  BooleanCell,
  DateFormatCell,
  formatDateForAPI,
} from "components/common/formatter";
import AddTime from "pages/Time/AddTime";
import { Popup } from "@progress/kendo-react-popup";
import FilterComponent from "../CaseFiles/FilterComponent";
import { FilterComponent as GeneraLFilters } from "components/common/FiltersComponent";
import MattersCombobox from "pages/Postings/MattersComboBox";
import { Label } from "@progress/kendo-react-labels";
import { getAccessRightsData } from "services/currentUserService";
import {
  RedirectCell,
  GRID_PAGE_SIZES,
} from "components/common/GridComponents";
import { toast } from "react-toastify";
import { useCompany } from "services/companyService";
import ActionbarSkelton from "components/common/Loaders/ActionbarSkelton";
import { AiOutlineFileText } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRecordedTimeForMatter,
  fetchRecordedTime,
} from "../../services/timeService";

const statusData = [
  { key: "All", value: "" },
  { key: "Billed", value: true },
  { key: "UnBilled", value: false },
];

const CenterTextHeaderCell = (props) => (
  <th className="text-center border-0" style={{ width: "150px" }}>
    <span className=".k-cell-inner">
      <span className="k-link">
        <span className="k-column-title">{props.title}</span>
      </span>
    </span>
  </th>
);

const TimeNotesCell = ({ dataItem }) => {
  const hasNote = dataItem?.fileNoteId != null && dataItem?.fileNoteId !== "";
  if (!hasNote) return <td className="text-center" />;
  return (
    <td className="text-center">
      <AiOutlineFileText
        className="text-primary"
        style={{ fontSize: "1.1rem" }}
        title="Time Note"
      />
    </td>
  );
};

export default function TimeRecorded(props) {
  const dispatch = useDispatch();
  const { MatterRecordedTime, recordedTime, isLoading } = useSelector(
    (state) => state.time,
  );

  const date = new Date();
  const [valueFrom, setValueFrom] = React.useState(false);
  const [valueTo, setValueTo] = React.useState(false);
  const [timeList, setTimeList] = useState({ data: [], total: 0 });
  const [loadedContent, setLoadedContent] = useState(true);
  const [matterId, setMatterId] = useState(null);
  const [status, setStatus] = useState({ key: "All", value: "" });
  const [allowAccessData, setAllowAccessData] = useState({});
  const { data: company } = useCompany();
  const [selectedMatter, setSelectedMatter] = useState(null);

  const [timeModal, setTimeModal] = useState({
    open: false,
    mode: "add",
    data: null,
  });

  const openAddTimeModal = (matter = null) => {
    setTimeModal({ open: true, mode: "add", data: matter });
  };

  const openEditTimeModal = (entry) => {
    if (entry?.billed) {
      toast.info("This time entry is already billed and cannot be viewed.");
      return;
    }
    setTimeModal({ open: true, mode: "edit", data: entry });
  };

  const closeTimeModal = () =>
    setTimeModal({ open: false, mode: "add", data: null });

  const handleRowClick = (dataItem) => openEditTimeModal(dataItem);

  let yearsStartDate = new Date(company.yearStartDate);
  if (isNaN(yearsStartDate)) {
    yearsStartDate = new Date();
  }

  const [fromDate, setFromDate] = useState(formatDateForAPI(yearsStartDate));
  const [toDate, setToDate] = useState(formatDateForAPI(date));
  const [dataState, setDataState] = React.useState({
    take: 50,
    skip: 0,
    sort: [
      {
        field: "date",
        dir: "asc",
      },
    ],
  });

  const Redirect = (props) => (
    <RedirectCell handleClick={() => handleRowClick(props.dataItem)} />
  );

  const [fromDateSelector, setFromDateSelector] = useState(yearsStartDate);
  const [toDateSelector, setToDateSelector] = useState(date);

  const fetchTimeData = (applyFilters = false) => {
    const page = Math.floor(dataState.skip / dataState.take) + 1;
    const sort = dataState.sort?.[0];

    if (props.fromCaseFile && props.selectedMatterId) {
      const params = {
        matterId: props.selectedMatterId,
        page,
        limit: dataState.take,
        sort,
      };
      if (applyFilters) {
        const statusForAPI = status.key === "All" ? null : status;
        params.status = statusForAPI;
        params.fD = valueFrom ? fromDate : "";
        params.tD = valueTo ? toDate : "";
      }

      dispatch(fetchRecordedTimeForMatter(params));
    } else if (!props.fromCaseFile && props.parameter) {
      const params = {
        feeEarner: props.parameter,
        page,
        limit: dataState.take,
      };
      if (applyFilters) {
        params.status = status;
        params.fD = valueFrom ? fromDate : null;
        params.tD = valueTo ? toDate : null;
        params.matterId = matterId?.matterId || null;
      } else {
        params.status = null;
        params.fD = null;
        params.tD = null;
        params.matterId = null;
      }
      
      dispatch(fetchRecordedTime(params));
    }
  };

  useEffect(() => {
    const page = Math.floor(dataState.skip / dataState.take) + 1;
    const sort = dataState.sort?.[0];

    if (props.fromCaseFile && props.selectedMatterId) {
      dispatch(
        fetchRecordedTimeForMatter({
          matterId: props.selectedMatterId,
          page,
          limit: dataState.take,
          sort,
        }),
      );
    } else if (!props.fromCaseFile && props.parameter) {
      dispatch(
        fetchRecordedTime({
          feeEarner: props.parameter,
          status: status,
          fD: valueFrom ? fromDate : null,
          tD: valueTo ? toDate : null,
          matterId: matterId?.matterId || null,
          page,
          limit: dataState.take,
        }),
      );
    }
  }, [
    props.selectedMatterId,
    props.parameter,
    props.fromCaseFile,
    dataState,
    dispatch,
    matterId,
  ]);

  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  
  useEffect(() => {
    if (!props.fromCaseFile && props.parameter && initialLoadComplete) {
      const page = 1;
      
      dispatch(fetchRecordedTime({
        feeEarner: props.parameter,
        status: status,
        fD: valueFrom ? fromDate : null,
        tD: valueTo ? toDate : null,
        matterId: matterId?.matterId || null,
        page,
        limit: dataState.take,
      }));
      if (dataState.skip !== 0) {
        setDataState(prev => ({ ...prev, skip: 0 }));
      }
    }
  }, [
    status, 
    valueFrom, fromDate,
    valueTo, toDate,
    props.fromCaseFile,
    props.parameter,
    initialLoadComplete,
    dataState.take,
    dispatch
  ]);

  useEffect(() => {
    if (
      props.fromCaseFile &&
      props.selectedMatterId &&
      MatterRecordedTime[props.selectedMatterId]
    ) {
      setTimeList(MatterRecordedTime[props.selectedMatterId]);
    } else if (!props.fromCaseFile && recordedTime) {
      setTimeList(recordedTime);
      setInitialLoadComplete(true);
    }
  }, [
    MatterRecordedTime,
    recordedTime,
    props.selectedMatterId,
    props.fromCaseFile,
  ]);

  useEffect(() => {
    if (props.refreshClicked && props.activeItem === 1) {
      ReloadData();
      props.setRefreshClicked(false);
    }
    else if (props.refreshClicked && !props.hasOwnProperty("activeItem")) {
      ReloadData();
      if (props.setRefreshClicked) {
        props.setRefreshClicked(false);
      }
    }

    if (props.addTime) {
      openAddTimeModal(props.matter || null);
      props.setAddTime(false);
    }
  }, [props.refreshClicked, props.addTime]);

  const getAccessRights = async () => {
    try {
      const data = await getAccessRightsData();
      setAllowAccessData(data?.data?.data);
      setLoadedContent(false);
    } catch (error) {}
  };

  useEffect(() => {
    getAccessRights();
  }, []);

  const onChangeFromDateSelect = (event) => {
    if (!valueFrom) {
      setValueFrom(true);
    }
    setFromDateSelector(event.value);
    let fromDate = null;
    let date = new Date(event.value);
    if (event.value) {
      fromDate = formatDateForAPI(date);
    }
    setFromDate(fromDate);
  };

  const onChangeToDateSelect = (event) => {
    if (!valueTo) {
      setValueTo(true);
    }
    setToDateSelector(event.value);
    let toDate = null;
    let date = new Date(event.value);
    if (event.value) {
      toDate = formatDateForAPI(date);
    }
    setToDate(toDate);
  };

  const onChangematter = (e) => {
    let event = e.value;
    setMatterId(event);
    setSelectedMatter(event);
  };

  const updateFilterValues = () => {
    const { setFilterClicked, setFilterApplied } = props;
    setFilterClicked(false);

    const hasDateFilters = valueFrom || valueTo;
    const hasStatusFilter = status.key !== "All" && status.value !== "";
    const hasAnyFilters = hasDateFilters || hasStatusFilter;

    if (!hasAnyFilters) {
      setFromDateSelector(yearsStartDate);
      setToDateSelector(date);
      setFilterApplied(false);
    } else {
      setFilterApplied(true);
    }

    if (props.fromCaseFile) {
      fetchTimeData(hasAnyFilters);
    }
  };

  const createState = (skip, take) => {
    let pagerSettings = {
      pageSizes: GRID_PAGE_SIZES,
    };
    return {
      pageSize: take,
      pageable: pagerSettings,
    };
  };

  const [state, setState] = React.useState(createState(0, 50));

  const onOpen = () => {};

  useEffect(() => {
    if (!props?.filterClicked) return;

    const handlePointerDown = (event) => {
      const anchorElement = props?.filterAnchor?.current;
      if (anchorElement && anchorElement.contains(event.target)) {
        return;
      }
      if (event.target?.closest?.(".k-calendar")) {
        return;
      }

      const popupElement = props?.filterContentRef?.current;
      const popupContainer = popupElement
        ? popupElement.closest(".k-animation-container")
        : null;

      const rect =
        popupContainer?.getBoundingClientRect?.() ||
        popupElement?.getBoundingClientRect?.();

      if (!rect) {
        props?.setFilterClicked(false);
        return;
      }

      const { clientX, clientY } = event;
      const isInside =
        clientX >= rect.left &&
        clientX <= rect.right &&
        clientY >= rect.top &&
        clientY <= rect.bottom;
      if (!isInside) {
        props?.setFilterClicked(false);
      }
    };

    document.addEventListener("pointerdown", handlePointerDown, true);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown, true);
    };
  }, [
    props?.filterClicked,
    props?.setFilterClicked,
    props?.filterAnchor,
    props?.filterContentRef,
  ]);

  let handleChange = (e) => {
    setStatus(e.target.value);
  };

  const dataStateChange = (e) => {
    setDataState(e.dataState);
  };

  const handleReset = () => {
    setValueFrom(false);
    setValueTo(false);
    setFromDateSelector(yearsStartDate);
    setToDateSelector(date);
    setFromDate(formatDateForAPI(yearsStartDate));
    setToDate(formatDateForAPI(date));
    setStatus({ key: "All", value: "" });
    props.setFilterApplied(false);
    props.setFilterClicked(false);

    fetchTimeData(false);
  };

  const ReloadData = () => {
    setDataState((prev) => ({
      ...prev,
      skip: 0,
    }));

  };

  const totalUnits = timeList?.data?.reduce(
    (acc, item) => acc + Number(item.units || 0),
    0,
  );
  const totalValue = timeList?.data?.reduce(
    (acc, item) => acc + Number(item.value || 0),
    0,
  );
  const totalBilledAmount = timeList?.data?.reduce(
    (acc, item) => acc + Number(item.billedNetAmount || 0),
    0,
  );

  return (
    <div className={`h-100 w-100 d-flex flex-column ${props.className}`}>
      {props.fromCaseFile ? (
        <Popup
          key={props?.filterClicked ? "open" : "closed"}
          show={props?.filterClicked}
          anchor={props?.filterAnchor?.current}
          anchorAlign={{
            horizontal: "right",
            vertical: "bottom",
          }}
          popupAlign={{
            horizontal: "right",
            vertical: "top",
          }}
          popupClass={` ${styles["popup-content"]}  `}
          onOpen={onOpen}
        >
          <div
            ref={props?.filterContentRef}
            role="menu"
            className="d-flex flex-column align-items-center"
          >
            <FilterComponent
              updateFilterValues={updateFilterValues}
              showPopup={true}
              valueFrom={valueFrom}
              setValueFrom={setValueFrom}
              fromDateSelector={fromDateSelector}
              onChangeFromDateSelect={onChangeFromDateSelect}
              valueTo={valueTo}
              setValueTo={setValueTo}
              toDateSelector={toDateSelector}
              onChangeToDateSelect={onChangeToDateSelect}
              statusData={statusData}
              status={status}
              handleChange={handleChange}
              handleReset={handleReset}
              handleAddTime={() => openAddTimeModal(selectedMatter)}
            />
          </div>
        </Popup>
      ) : loadedContent ? (
        <ActionbarSkelton length={4} />
      ) : (
        <div className="d-flex align-items-end flex-wrap gap-2 mb-3 justify-content-start">
          <GeneraLFilters
            allowAccessData={allowAccessData}
            updateFilters={(data) => {}}
            disabledFeeEarner={true}
            inlineLayout
          />
          <div
            className="d-flex flex-column"
            style={{
              minWidth: "165px",
              maxWidth: "250px",
              flex: "1 1 0%",
            }}
          >
            <Label className="filter-font mb-1">Matter</Label>
            <MattersCombobox
              onChangematter={onChangematter}
              value={matterId}
              style={{ width: "100%", height: "40px" }}
            />
          </div>

          <FilterComponent
            valueFrom={valueFrom}
            setValueFrom={setValueFrom}
            fromDateSelector={fromDateSelector}
            onChangeFromDateSelect={onChangeFromDateSelect}
            valueTo={valueTo}
            setValueTo={setValueTo}
            toDateSelector={toDateSelector}
            onChangeToDateSelect={onChangeToDateSelect}
            statusData={statusData}
            status={status}
            handleChange={handleChange}
            handleRefresh={ReloadData}
            handleAddTime={() => openAddTimeModal(selectedMatter)}
            refreshLabelClassName={styles["refresh-label-icon-only"]}
            toolbarInline
          />
        </div>
      )}

      <Grid
        {...dataState}
        data={timeList}
        onDataStateChange={dataStateChange}
        sortable={true}
        className="fs-md flex-grow-1 overflow-auto casefile_outlook_grid grid-minwidth-col5-150"
        pageable={state.pageable}
        pageSize={state.pageSize}
        loading={isLoading}
      >
        <GridColumn
          field="date"
          title="Date"
          cell={DateFormatCell}
          width="110px"
        />
        <GridColumn field="timeTypeCode" title="Type" width="80px" />
        <GridColumn field="feeEarnerRef" title="FE" width="80px" />
        <GridColumn field="matterRef" title="Matter Ref" width="120px" />
        <GridColumn field="details" title="Details" />
        <GridColumn
          title=""
          width="50px"
          className="text-center"
          cell={(cellProps) => <TimeNotesCell dataItem={cellProps.dataItem} />}
        />
        <GridColumn
          field="units"
          title="Units"
          width="70px"
          className="text-center"
          footerCell={() => (
            <td className="fw-bold text-center ps-2">{totalUnits}</td>
          )}
        />

        <GridColumn
          field="rate"
          title="Rate"
          headerCell={CenterTextHeaderCell}
          cell={AmountFormatCell}
          width="80px"
        />
        <GridColumn
          field="value"
          title="Value"
          headerCell={CenterTextHeaderCell}
          cell={AmountFormatCell}
          width="80px"
          footerCell={() => (
            <td className="fw-bold text-end pe-2">{totalValue?.toFixed(2)}</td>
          )}
        />
        <GridColumn
          field="billed"
          className="ms-auto"
          title="Billed"
          headerCell={CenterTextHeaderCell}
          cell={BooleanCell}
          width="80px"
        />

        <GridColumn
          field="billedNetAmount"
          title="Bill Amt"
          width="100px"
          headerCell={CenterTextHeaderCell}
          cell={AmountFormatCell}
          footerCell={() => (
            <td className="fw-bold text-end pe-2">{totalValue?.toFixed(2)}</td>
          )}
        />

        <GridColumn width="60px" cells={{ data: Redirect }} />
      </Grid>

      {timeModal.open && (
        <Dialog
          title={timeModal.mode === "add" ? "Add Time" : "View Time Entry"}
          className="dialog-md"
          onClose={closeTimeModal}
        >
          <AddTime
            component="modal"
            fromCaseFile={true}
            showModal={closeTimeModal}
            mode={timeModal.mode}
            initialData={timeModal.data}
            matter={timeModal.mode === "edit" ? timeModal : timeModal.data}
            cancelEdit={closeTimeModal}
            fetchTime={ReloadData}
          />
        </Dialog>
      )}
    </div>
  );
}
